export const RSVP_WHATSAPP_LANGUAGES = [
  { value: "pt_BR", label: "Português (Brasil)" },
  { value: "en_US", label: "English (US)" },
  { value: "es", label: "Español" },
];
export const RSVP_BUSINESS_FEEDBACK_KEYS = ["confirmed", "declined", "closed"];
const group = (title, desc, small = "") => ({ title, desc, small });
const recorded = {
  pt: group("Resposta registrada", "Registramos sua resposta."),
  en: group("Response recorded", "We have recorded your response."),
  es: group("Respuesta registrada", "Hemos registrado tu respuesta."),
};
const messages = {
  pt: {
    confirmed: recorded.pt, declined: recorded.pt,
    closed: group("Prazo encerrado", "O período para responder a este RSVP terminou.", "Sua resposta anterior, se houver, permanece registrada."),
    invitation_expired: group("Este convite expirou", "Não é possível responder usando este convite.", "Solicite um convite atual ao organizador."),
    invalid_invitation: group("Convite indisponível", "Este convite não pode ser utilizado.", "Solicite um convite atual ao organizador."),
    needs_review: group("Sua resposta precisa de revisão", "O organizador precisa revisar sua resposta antes de receber uma nova escolha.", "Fale com o organizador."),
    error: group("Não foi possível registrar", "Sua nova resposta não foi registrada.", "Tente novamente ou fale com o organizador."),
  },
  en: {
    confirmed: recorded.en, declined: recorded.en,
    closed: group("Response deadline passed", "The response period for this RSVP has ended.", "Your previous response, if any, remains recorded."),
    invitation_expired: group("This invitation has expired", "You cannot respond using this invitation.", "Ask the organizer for a current invitation."),
    invalid_invitation: group("Invitation unavailable", "This invitation cannot be used.", "Ask the organizer for a current invitation."),
    needs_review: group("Your response needs review", "The organizer needs to review your response before accepting another choice.", "Contact the organizer."),
    error: group("Unable to record response", "Your new response was not recorded.", "Try again or contact the organizer."),
  },
  es: {
    confirmed: recorded.es, declined: recorded.es,
    closed: group("Plazo finalizado", "El período para responder a este RSVP ha terminado.", "Tu respuesta anterior, si existe, sigue registrada."),
    invitation_expired: group("Esta invitación ha caducado", "No puedes responder con esta invitación.", "Solicita una invitación actual al organizador."),
    invalid_invitation: group("Invitación no disponible", "Esta invitación no se puede utilizar.", "Solicita una invitación actual al organizador."),
    needs_review: group("Tu respuesta necesita revisión", "El organizador debe revisar tu respuesta antes de aceptar otra opción.", "Contacta con el organizador."),
    error: group("No se pudo registrar", "Tu nueva respuesta no se ha registrado.", "Inténtalo de nuevo o contacta con el organizador."),
  },
};
export const normalizeRsvpFeedbackLanguage = (value) => {
  const match = /^([a-z]{2,3})(?:[-_]([a-z]{2}|\d{3}))?$/i.exec(String(value || "").trim());
  return match ? match[1].toLowerCase() + (match[2] ? "_" + match[2].toUpperCase() : "") : null;
};
export const rsvpFeedbackMessageKey = (outcome) => ({
  changed_yes: "confirmed", already_yes: "confirmed", changed_no: "declined", already_no: "declined",
  unavailable: "invalid_invitation", uncertain: "error",
}[outcome] || outcome);
export const defaultRsvpWhatsAppFeedback = (language, outcome) => {
  const base = normalizeRsvpFeedbackLanguage(language)?.split("_")[0];
  const dictionary = messages[base] || messages.en;
  return { ...(dictionary[rsvpFeedbackMessageKey(outcome)] || dictionary.error) };
};
export function normalizeRsvpFeedbackTranslations(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const result = {};
  for (const [rawLanguage, feedback] of Object.entries(value).slice(0, 100)) {
    const language = normalizeRsvpFeedbackLanguage(rawLanguage);
    if (!language || !feedback || typeof feedback !== "object" || Array.isArray(feedback)) continue;
    const entries = {};
    for (const key of RSVP_BUSINESS_FEEDBACK_KEYS) {
      const input = feedback[key];
      if (!input || typeof input !== "object" || Array.isArray(input)) continue;
      const item = Object.fromEntries(["title", "desc", "small"].map((field) => [field, String(input[field] ?? "").trim().slice(0, 500)]));
      if (Object.values(item).some(Boolean)) entries[key] = item;
    }
    if (Object.keys(entries).length) result[language] = entries;
  }
  return result;
}
export const rsvpWhatsAppAnswerText = (language, label) => {
  const base = normalizeRsvpFeedbackLanguage(language)?.split("_")[0];
  const prefix = ({ pt: "Resposta selecionada", en: "Selected response", es: "Respuesta seleccionada" })[base];
  // This is a plain-text value, never a template expression or formatting instruction.
  const text = String(label || "").replace(/[\u0000-\u001f\u007f]/g, " ").trim().slice(0, 120);
  return text ? prefix ? `${prefix}: ${text}` : `“${text}”` : "";
};
